module.exports = __webpack_public_path__ + "img/vr_marker.df5957a6.png";